import { ReservationService } from "../../services/reservation-service/reservation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { FineService } from "./fine.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";

import swal from "sweetalert2";

@Component({
  selector: "app-fines-view",
  templateUrl: "./fines-view.component.html",
  styleUrls: ["./fines-view.component.css"],
})
export class FinesViewComponent implements OnInit {
  id;

  reservation;
  contractTerms;

  fines = [];

  userProfile = JSON.parse(window.localStorage.getItem("userProfile"));

  get leadPhones() {
    return [
      this.reservation.sharing_leads[0].lead_phone,
      this.reservation.sharing_leads[0].lead_phone_2,
      this.reservation.sharing_leads[0].lead_phone_3,
      this.reservation.sharing_leads[0].lead_phone_4,
      this.reservation.sharing_leads[0].lead_phone_5,
      this.reservation.sharing_leads[0].lead_phone_6,
    ]
      .filter((a) => a)
      .join(", ");
  }

  constructor(
    public fineService: FineService,
    public reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    if (!this.id) {
      this.router.navigate([".."]);
    }
    this.getReservation();
    this.getContractTerms();
    this.getFines();
  }

  getFines(is_export = false) {
    this.fineService
      .getFines({ filter_reservation: this.id, paginate: "false", is_export })
      .subscribe((res: any) => {
        if (is_export) {
          window.open(res.url, "_blank");
        } else {
          this.fines = res;
        }
      });
  }

  deleteFine(ids) {
    let payload = {
      ids: Array.isArray(ids) ? ids : [ids],
    };
    this.fineService.deleteFine(this.id, payload).subscribe(
      (res: any) => {
        this.getFines();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getReservation() {
    this.reservationService
      .getSingleReservation(this.id)
      .subscribe((res: any) => {
        if (res.data[0]) {
          this.reservation = res.data[0];
        } else {
          this.router.navigate([".."]);
        }
      });
  }

  getContractTerms() {
    this.reservationService.getContractTerms(this.id).subscribe((res) => {
      this.contractTerms = res;
    });
  }

  approve(fine) {
    const payload = {
      ids: [fine.id],
      status: "approved",
    };
    this.fineService.changeApprovedStatus(this.id, payload).subscribe((res) => {
      this.getFines();
      swal("success", "Changed fine to approved succesfully", "success");
    });
  }

  reject(fine) {
    const payload = {
      ids: [fine.id],
      status: "rejected",
    };
    this.fineService.changeApprovedStatus(this.id, payload).subscribe((res) => {
      this.getFines();
      swal("success", "Changed fine to rejected succesfully", "success");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/fines-view/fines-view.component.ts